exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vs_select_over .vs__dropdown-menu {\n  position: relative;\n}\n.vue_select_drop_size_98 .vs__dropdown-menu {\n  max-height: 98px;\n}", ""]);

// exports
